import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { alpha, Chip, Skeleton, Tooltip } from "@mui/material";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import { fetchSchoolCurrentTerm } from "../utils/currentTermUtils";
import { getSchoolIdForUser } from "../utils/userContext";

/** Current term chip for teacher / form teacher portals — no fee data. */
export default function StaffCurrentTermIndicator({ linkTo = "/Teacher/academic-calendar" }) {
    const { currentUser } = useSelector((state) => state.user);
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const schoolId = getSchoolIdForUser(currentUser) || currentUser?.school?._id || currentUser?.schoolId;
    const schoolType = currentUser?.schoolType || currentUser?.school?.schoolType || "Secondary";

    useEffect(() => {
        if (!schoolId || schoolType === "University") {
            setInfo(null);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        fetchSchoolCurrentTerm({ schoolId, schoolType, includeFees: false })
            .then((result) => {
                if (!cancelled) setInfo(result);
            })
            .catch(() => {
                if (!cancelled) setInfo(null);
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [schoolId, schoolType]);

    if (schoolType === "University") return null;

    if (loading) {
        return <Skeleton variant="rounded" width={120} height={28} sx={{ mr: 1 }} />;
    }

    if (!info?.label) return null;

    return (
        <Tooltip title="View academic calendar and term deadlines">
            <Chip
                icon={<EventAvailableOutlinedIcon />}
                label={info.label}
                size="small"
                component={RouterLink}
                to={linkTo}
                clickable
                variant="outlined"
                sx={{
                    mr: 1,
                    color: "inherit",
                    borderColor: alpha("#fff", 0.45),
                    fontWeight: 600,
                    "& .MuiChip-icon": { color: "inherit" },
                }}
            />
        </Tooltip>
    );
}
